import React, {useEffect, createRef} from 'react';

import { useStateValue } from './state';

export const LogPanel = () => {
    const [{log}, ] = useStateValue();

    const ref = createRef();

    useEffect(() => {

        ref.current.scrollIntoView(
            {
            behavior: 'smooth',
            block: 'end'
        }
        );

    }, [log.length, ref]);



    return (<div className='logMsgPanel' >
        {log.slice(0).map((item, index) => {

            let displayMsg = item;
            if(item === 'error: Network Failure') {
                displayMsg += '.  Be sure DynamoDB is available and running via the connection defined in /src/connect.js';
            }

            return (
                    <div className={ item.search(/error/i) === -1 && item.search(/exception/i) === -1 ? 'logMsgContent' : 'logMsgError'} key={index}>{displayMsg} </div>
                );
            }
        )}
        <div ref={ref} />

    </div>);

};



